<template>
  <v-dialog
    v-model="dialog"
    max-width="420"
    :teleport="'body'"
    content-class="email-dialog"
  >
    <v-card>
      <v-card-title class="headline">
        メール送信先の確認
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="contactEmail"
          label="宛先メールアドレス"
          variant="outlined"
          density="compact"
          :rules="[rules.required, rules.email]"
        />
        <p class="body-2 text-grey mt-2">
          ※ 添付ファイルをメールにて送信します。<br/> ※ 送信先の間違いにご注意ください。
        </p>
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-end">
        <v-btn variant="text" @click="$emit('close')">キャンセル</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click="onSubmit"
          variant="flat"
        >メール送信</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import rules from '@/service/ValidRules';
import { chatModule } from '@/store/entityModules/chat';

export default defineComponent({
  props: {
    modelValue: { type: Boolean, required: true },   // v-model
    chatId: { type: Number, required: false },
    email: { type: String, required: false },
  },
  data() {
    return {
      targetChatId: this.chatId,
      contactEmail: this.email,
      loading: false,
      rules,
    };
  },
  watch: {
    chatId(newVal: number) {
      this.targetChatId = newVal;
    },
    email(newVal: string) {
      this.contactEmail = newVal;
    },
  },
  computed: {
    dialog: {
      get(): boolean {
        return this.modelValue;
      },
      set(val: boolean) {
        this.$emit('update:modelValue', val);
      },
    },
  },
  methods: {
    async onSubmit() {
      if (!this.targetChatId) {
        this.$emit('error', '恐れ入りますが、現在ご利用できません');
        return;
      }

      if (!this.contactEmail) {
        this.$emit('error', 'メールアドレスが入力されていません');
        return;
      }

      this.loading = true;
      try {
        await chatModule.sendChatAttachment({
          chatId: this.chatId as number,
          contactEmail: this.contactEmail,
        })

        this.$emit('success', 'メールを送信しました');
        this.dialog = false;
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>
<style>
:deep(.v-overlay) {
  z-index: 9998 !important;
}
:deep(.v-overlay-container) {
  z-index: 9999 !important;
}
:deep(.email-dialog) {
  z-index: 10000 !important;
}
</style>
